import { render, staticRenderFns } from "./MainView.vue?vue&type=template&id=b2a173a6&scoped=true"
import script from "./MainView.vue?vue&type=script&lang=js"
export * from "./MainView.vue?vue&type=script&lang=js"
import style0 from "./MainView.vue?vue&type=style&index=0&id=b2a173a6&prod&lang=css"
import style1 from "./MainView.vue?vue&type=style&index=1&id=b2a173a6&prod&lang=scss&scoped=true"
import style2 from "./MainView.vue?vue&type=style&index=2&id=b2a173a6&prod&lang=scss&scoped=true"
import style3 from "./MainView.vue?vue&type=style&index=3&id=b2a173a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a173a6",
  null
  
)

export default component.exports